// extracted by mini-css-extract-plugin
export default {"container":"Main_container__8pvQH","mainContent":"Main_mainContent__30ew6","contentWrapper":"Main_contentWrapper__BOaxE","contentArea":"Main_contentArea__IkdLx"};